
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/irpf/[videoId]",
      function () {
        return require("private-next-pages/irpf/[videoId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/irpf/[videoId]"])
      });
    }
  